export const cssSubResponsive = {
      graphMgZoom: {
        marginBottom: 30,
      }
};
